export const environment = {
  domain: 'aando.cloud',
  production: false,
  stand: '| STAGING',
  siteUrl: 'https://id.aando.cloud/',
  profileUrl: 'https://id.aando.cloud/profile',
  publicSiteUrl: 'https://www.aanjapan.co.jp',
  apolloClientsConfig: [
    {
      clientName: 'auth',
      endpoint: 'https://id.aando.cloud/graphql/auth',
      fetchPolicy: 'network-only',
    },
    {
      clientName: 'core',
      endpoint: 'https://id.aando.cloud/graphql/core',
      fetchPolicy: 'network-only',
    },
  ],
};
